import { render } from "./Greeting.vue?vue&type=template&id=66aa149b&scoped=true"
import script from "./Greeting.vue?vue&type=script&lang=js"
export * from "./Greeting.vue?vue&type=script&lang=js"

import "./Greeting.vue?vue&type=style&index=0&id=66aa149b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66aa149b"]])

export default __exports__